import { gql } from '@apollo/client';

/**
 * 创建异步账单汇总任务
 */
export const CREATE_ASYNC_BILL_SUMMARY = gql`
  mutation CreateAsyncBillSummary($billId: ID!) {
    createAsyncBillSummary(billId: $billId) {
      taskId
      success
      message
    }
  }
`;

